import axios from "axios";

export default function OrderCreateReceiptService(orderId, receiptGroupId) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/order/" + orderId + "/createReceipt/" + receiptGroupId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
